// extracted by mini-css-extract-plugin
export var calendarView = "_kr-0";